
    <div class="aip-toolbar" *ngIf="true">
        <button style="min-width:46px;margin-right:5px" mat-raised-button class="aip-button" (click)="addTable()">
            Add    
        </button>
        <button [disabled]="selectedRow==null" style="min-width:46px;margin-right:5px" mat-raised-button class="aip-button" (click)="editTable(selectedRow)">
            Edit  
        </button>       
        
        <span class="spacer"></span>


    </div>

<mat-card class="aip-widget-fullscreen mat-elevation-z4">

<mat-card-content class="aip-widget-content-fullscreen">
  <ng-container *ngIf="!this.isData">
    <div style="width:100%;height:100%">
      <mat-spinner diameter=50 class="aip-spinner"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="this.isData">

    <app-table-grid [tableDef]="tableDef" [data]="data" [loading]="loading" (edit)="editTable($event)" (select)="selectRow($event)" (reload)="loadData()"></app-table-grid>

  </ng-container>


</mat-card-content>
</mat-card>